export default "__VITE_ASSET__DrNUd7V3__"